// Unified product-name resolution. Used by Recent Orders, Timeline, full Order
// History, Feedback lists — anywhere an order/item needs a display name.

const TEST_SKUS = new Set(['TEST', 'TESTSKU', 'DEMO', 'SAMPLE']);
const isTestSku = (sku) => !!sku && TEST_SKUS.has(String(sku).trim().toUpperCase());
const bad = (s) => !s || /unknown/i.test(String(s));

// Resolve a single order item's name.
export const resolveItemName = (item = {}, productsMap = {}) => {
    const sku = item.sku || item.productId || item.productCode || '';
    if (isTestSku(sku)) return 'Test Product';
    if (!bad(item.productName)) return item.productName;
    if (!bad(item.name)) return item.name;
    if (!bad(item.title)) return item.title;
    const pm = productsMap[sku] || productsMap[item.productId];
    if (pm && pm.name) return pm.name;
    if (sku) return `Product SKU: ${sku}`;
    return 'Unknown Product';
};

// Resolve an order's product display (joins item names; falls back through
// snapshot fields and the products map; "Test Product" for test SKUs).
export const resolveOrderProduct = (order = {}, productsMap = {}) => {
    if (Array.isArray(order.items) && order.items.length) {
        const names = order.items.map(it => resolveItemName(it, productsMap)).filter(n => !bad(n) && !/^Product SKU:/.test(n));
        if (names.length) return names.join(', ');
        // All names unknown but a SKU may resolve via productsMap / SKU display.
        const withSku = order.items.find(it => it.sku || it.productId);
        if (withSku) return resolveItemName(withSku, productsMap);
    }
    if (!bad(order.productSummary)) return order.productSummary;
    if (Array.isArray(order.productNames)) {
        const n = order.productNames.find(x => !bad(x));
        if (n) return n;
    }
    if (!bad(order.productName)) return order.productName;
    const sku = order.productCode || order.sku || '';
    if (isTestSku(sku)) return 'Test Product';
    const pm = productsMap[sku];
    if (pm && pm.name) return pm.name;
    if (sku) return `Product SKU: ${sku}`;
    return 'Unknown Product';
};
